import validate from "/app/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emna_c6a401450941ae20eebcc05a83eb29fd/node_modules/nuxt/dist/pages/runtime/validate.js";
import disable_45vue_45transitions_45global from "/app/app/middleware/disable-vue-transitions.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emna_c6a401450941ae20eebcc05a83eb29fd/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  disable_45vue_45transitions_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}